<template>
    <div class="pageBox">
        <div class="option">
            <el-select v-model="questionType" @change="topicChange" placeholder="请选择咨询主题" clearable>
                <el-option v-for="item in topicList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input style="width: 300px;" placeholder="输入客户名称进行搜索" v-model="name">
                <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
            </el-input>
        </div>
        <div class="table" ref="table">
            <el-table element-loading-text="数据加载中..." v-loading="loading" stripe :height='height' :data="list" border>
                <el-table-column prop="name" label="客户姓名" align="center" width="120">
                </el-table-column>
                <el-table-column prop="phone" label="联系电话" align="center" width="170">
                </el-table-column>
                <el-table-column prop="email" label="电子邮箱" align="center" width="220">
                </el-table-column>
                <el-table-column prop="questionType" label="咨询主题" align="center" width="140">
                </el-table-column>
                <el-table-column prop="content" label="留言内容" align="center">
                </el-table-column>
                <el-table-column prop="createTime" label="留言日期" align="center" width="220">
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button @click="check(scope.row)" type="text">查看</el-button>
                        <el-button @click="remove(scope.row)" type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="bottom">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current"
                :page-sizes="[20, 40, 60, 80, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="查看" :visible.sync="dialogShow" width="30%">
            <el-form label-width="90px">
                <el-form-item label="客户姓名">
                    <el-input v-model="detail.name" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input v-model="detail.phone" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="电子邮箱">
                    <el-input v-model="detail.email" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="咨询主题">
                    <el-input v-model="detail.questionType" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="留言内容">
                    <el-input v-model="detail.content" :readonly="true" type="textarea" :rows="5"></el-input>
                </el-form-item>
                <el-form-item label="留言日期">
                    <el-input v-model="detail.createTime" :readonly="true"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">关闭</el-button>

            </span>
        </el-dialog>
    </div>
</template>
<script>
import { customerMessageList, customerMessageRemove } from '../api.js';
export default {
    data() {
        return {
            list: [],
            topicList: [
                {
                    value: '产品咨询', label: '产品咨询'
                },
                {
                    value: '价格咨询', label: '价格咨询'
                },
                {
                    value: '合作洽谈', label: '合作洽谈'
                },
                {
                    value: '技术支持', label: '技术支持'
                },
                {
                    value: '其他问题', label: '其他问题'
                }
            ],
            current: 1,
            size: 20,
            questionType: null,
            name: "",
            total: 0,
            height: 0,
            loading: true,
            dialogShow: false,
            detail: {},

        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getElementHeight()
        })
        this.getList()
    },
    methods: {
        getList() {
            this.loading = true
            customerMessageList({ current: this.current, size: this.size, questionType: this.questionType, name: this.name }).then(res => {
                if (res.code == 0) {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                }
            })
        },
        remove(row) {
            this.$confirm(`确定要删除该客户留言吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                customerMessageRemove(row.id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '删除成功'
                        });
                        this.current = 1
                        this.getList()
                    }
                })
            }).catch(() => {
            });
        },
        check(row) {
            this.detail = row
            this.dialogShow = true
        },
        handleSizeChange(val) {
            this.current = 1
            this.size = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.current = val
            this.getList()
        },
        getElementHeight() {
            const container = this.$refs.table;
            if (container) {
                this.height = container.offsetHeight
            }
        },
        topicChange() {
            this.getList()
        }
    }
}
</script>
<style scoped lang="less">
.pageBox {
    width: 100%;
    height: 100%;
    padding: 20px 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .option {
        margin-bottom: 20px;
        display: flex;
        gap: 20px;
    }

    .table {
        flex: 1;
    }

    .bottom {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>